const articleFixBar = () => {
  const newsBar = $('.news-bar');
  const config = 330;
  let position = 0;

  if (newsBar.length > 0) {
    $(window).scroll(function () {
      // get current position
      position = $(this).scrollTop();

      /*
      * verifies that the current position is greater than the configured position,
      * if it adds the `nav--fixed` class
      */
      if (position > config) {
        newsBar.addClass('news-bar--active');
      } else {
        newsBar.removeClass('news-bar--active');
      }
    }).scroll();
  }
};

const articleFixSocialShare = () => {
  const newsIntealSocial = $('.news-internal-social');
  const newsBar = $('.news-bar');
  const config = 330;
  let position = 0;

  $(window).resize(() => {
    if (newsBar.length > 0) {
      $(window).scroll(function () {
        // get current position
        position = $(this).scrollTop();

        /*
        * verifies that the current position is greater than the configured position,
        * if it adds the `nav--fixed` class
        */
        if (position > config) {
          newsBar.addClass('news-bar--active');
          newsIntealSocial.addClass('news-internal-social--active');
        } else {
          newsBar.removeClass('news-bar--active');
          newsIntealSocial.removeClass('news-internal-social--active');
        }
      }).scroll();
    }
  }).resize();
};

export {
  articleFixBar,
  articleFixSocialShare
};



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/articles/articleFixBar.js